import { Enums } from '../../helper/enums';

export namespace TicketModule {

    export class Ticket implements ITicket {

        public clientId: number;
        public contractId: number;
        public createdByContactId: number;
        public createdByTechnicianId: number;
        public createdOn: any;
        public isActive: boolean;
        public isMerged: boolean;
        public mergedlongoTicketId: number;
        public serviceProviderId: number;
        public serviceProviderTicketId: string;
        public updatedByContactId: number;
        public updatedByTechnicianId: number;
        public updatedOn: Date;
        public onSite: boolean;
        public ticketId: string;
        public ticketTitle: string;
        public ticketStatusId: string;
        public ticketStatusName: string;
        public ticketPriorityId: string;
        public ticketPriorityName: string;
        public ticketSeverityId: string;
        public ticketSourceId: string;
        public assignedToId: string;
        public assignedToTechnicianName: string;
        public contactId: string;
        public ticketAssets: any;
        public ticketAttachments: any;
        public ticketTags: any;
        public ticketTypeId: string;
        public crmJson: any; //ITicketCRM;
        public contactName: string;
        public contactDetailName: string;
        public contactDetailPhone: string;
        public contactDetailEmail: string;
        public customCreatedOn: string;
        public ticketStatus: string;

        public constructor(ticketId: string, ticketTitle: string, ticketStatus: string, ticketPriority: string, ticketSeverity: string
            , ticketSourceName: string, ticketAssignee: string, ticketcontactId: string, ticketAsset: any
            , ticketAttachments: any, ticketTags: any, ticketTypeId: string, crmJson: ITicketCRM|null, onSite: boolean,
            ticketPriorityName: string, ticketStatusName: string, assignedToTechnicianName: string, contactName: string, contactDetailName: string,
            contactDetailPhone: string, contactDetailEmail: string, customCreatedOn: string) {
            this.ticketId = ticketId;
            this.ticketTitle = ticketTitle;
            this.ticketStatusId = ticketStatus;
            this.ticketPriorityId = ticketPriority;
            this.ticketSeverityId = ticketSeverity;
            this.ticketSourceId = ticketSourceName;
            this.assignedToId = ticketAssignee;
            this.contactId = ticketcontactId;
            this.ticketAssets = ticketAsset;
            this.ticketAttachments = ticketAttachments;
            this.ticketTags = ticketTags;
            this.ticketTypeId = ticketTypeId;
            this.crmJson = crmJson;
            this.onSite = onSite;
            this.ticketPriorityName = ticketPriorityName;
            this.ticketStatusName = ticketStatusName;
            this.assignedToTechnicianName = assignedToTechnicianName;
            this.contactName = contactName;
            this.contactDetailName = contactDetailName;
            this.contactDetailPhone = contactDetailPhone;
            this.contactDetailEmail = contactDetailEmail;
            this.customCreatedOn = customCreatedOn;
        }
    }

    export interface ITicket {
        ticketId: string;
        ticketTitle: string;
        ticketStatusId: string;
        ticketPriorityId: string;
        ticketSeverityId: string;
        ticketSourceId: string;
        assignedToId: string;
        contactId: string;
        ticketAssets: any;
        ticketAttachments: any;
        ticketTags: any;
        ticketTypeId: string;
        crmJson: ITicketCRM;
        clientId: number;
        contractId: number;
        createdByContactId: number;
        createdByTechnicianId: number;
        createdOn: Date;
        isActive: boolean;
        isMerged: boolean;
        mergedlongoTicketId: number;
        serviceProviderId: number;
        serviceProviderTicketId: string;
        updatedByContactId: number;
        updatedByTechnicianId: number;
        updatedOn: Date;
        onSite: boolean;
        ticketPriorityName: string;
        ticketStatusName: string;
        assignedToTechnicianName: string;
        contactName: string;
        contactDetailName: string;
        contactDetailPhone: string;
        contactDetailEmail: string;
        customCreatedOn: string;
        ticketStatus: string;
    }

    export interface ITicketCRM {
        contactId: number;
        firstname: string;
        middlename: string;
        lastname: string;
        emailaddress: string;
        cellphoneno: string;
        phone: string;
        phoneext: string;
        clientid: string;
        clientname: string;
    }

    export interface ITicketVM {
        OldTicketTags: string[];
        NewTicketTags: string[];
        TicketTitle: string;
        onSite: boolean;
        ContactId: number | null;
        AssignedToId: number | null;
        TicketStatusId: number;
        TicketPriorityId: number;
        TicketSeverityId: number;
        TicketSourceId: number;
        TicketTypeId: number;
        TicketAssets: string[];
        TicketDescription: string;

    }
    export class TicketState {
        public ticketTitle: string;
        public clientId: number;
        public contactIds: number[];
        public ticketStatusId: any;
        public technicianGroupId: number;
        public ticketPriorityId: any;
        public ticketSourceId: any;
        public tagIds: number[];
        public assetIds: string[];
        public comment: string;
        public attachments: any[];
        public ticketTechnicians: TicketModule.Technician[];
        public doNotEmailCheck: boolean

    }

    export class TicketManageVm implements ITicketVM {

        public OldTicketTags: string[];
        public NewTicketTags: string[];
        public TicketTitle: string;
        public onSite: boolean;
        public ContactId: number | null;
        public AssignedToId: number | null;
        public TicketStatusId: number;
        public TicketPriorityId: number;
        public TicketSeverityId: number;
        public TicketSourceId: number;
        public TicketTypeId: number;
        public TicketAssets: string[];
        public TicketDescription: string;
        public ClientId: number | null;
        public ClientName: string;
        public attachments: Attachments[];
        public isTicketCreatedThroughAlert: boolean;
        public deviceId: string;
        public secondaryTechnicians: number[];
        public watchers: number[];
        public secondaryContacts: number[];
        public technicianGroupIds: number[];
        public emailConfigurationId: number | null;
        public markdownComment: string;
        public ticketLocation: number;
        public doNotEmailCheck: boolean

        public constructor(
            __OldTicketTags: string[],
            __NewTicketTags: string[],
            __TicketTitle: string,
            __onSite: boolean,
            __ContactId: number | null,
            __AssignedToId: number | null,
            __TicketStatusId: number,
            __TicketPriorityId: number,
            __TicketSeverityId: number,
            __TicketSourceId: number,
            __TicketTypeId: number,
            __TicketAssets: string[],
            __TicketDescription: string,
            __TicketAssetsToAdd: string[],
            __ClientId: number | null,
            __clientName: string,
            __ticketLocation: number,
            __doNotEmailCheck: boolean
        ) {
            this.OldTicketTags = __OldTicketTags;
            this.NewTicketTags = __NewTicketTags;
            this.TicketTitle = __TicketTitle;
            this.onSite = __onSite;
            this.ContactId = __ContactId;
            this.AssignedToId = __AssignedToId;
            this.TicketStatusId = __TicketStatusId;
            this.TicketPriorityId = __TicketPriorityId;
            this.TicketSeverityId = __TicketSeverityId;
            this.TicketSourceId = __TicketSourceId;
            this.TicketTypeId = __TicketTypeId;
            this.TicketAssets = __TicketAssets;
            this.TicketDescription = __TicketDescription;
            this.ClientId = __ClientId;
            this.ClientName = __clientName;
            this.ticketLocation = __ticketLocation;
            this.doNotEmailCheck = __doNotEmailCheck;
        }
    }

    export class TicketCommentCosmosResponse {
        public count: number;
        public comments: TicketComment[];
    }

    export class TicketComment {

        public type: string;
        public ticketId: string;
        public comment: string;
        public markdownComment: string;
        public statusId: number;
        public attachments: Attachments[] = [];
        public sourceId?: number;
        public lastAction?: number;
        public isInternal: boolean;
        public isPrimary: boolean;
        public isDeleted: boolean;
        public inboundEmailId!: number;
        public createdByContactId!: number;
        public createdByTechnicianId!: number;
        public serviceProviderId: number;
        public updatedOn: Date;
        public updatedByContactId: number;
        public updatedByTechnicianId: number;
        public id: string;
        public ticketTimeLineType: string;
        public action: string
        public previousValue: string;
        public newValue: string;
        public tick: number;
        public ticketState: string;
        public mentions: TicketModule.CommentMentions[] = [];
        public isPinned: boolean;
        public thirdPartyConversationId: number;
        public thirdPartyConversationEmail: string;
        public approvalId: string;
        public reactions: CommentReactions;
        public todoId: number;
        public trackingNumber: string;
        public trackingId: string;
        public slug: string;
        public checkpoint: TicketTrackingCheckpoint;
        public isSuccess: boolean = true;
        public localId: number;
        public showMoreComment: boolean;
        public ticketMacroId: number | null;
        public mentionedTechnicianGroupIds: number[];
        public clientId: number;
        public clientName: string;
        public showTooltip: boolean = false;
        public tooltipText: string = '';
        public sendSignalR: boolean = true;

        public constructor(
            __ticketId: string, __comment: string, __isInternal: boolean, __isPrimary: boolean, __id: string) {
            this.ticketId = __ticketId;
            this.comment = __comment;
            this.isInternal = __isInternal;
            this.isPrimary = __isPrimary;
            this.id = __id;
        }
    }

    export class CommentDraft {
        public entityId: string;
        public ticketCommentModel: TicketComment
        public commentTabId: number
        public isExtendedView: boolean
    }

    export class Attachments {
        public documentTypeId: number;
        public blobPath: string;
        public name: string;
        public isDeleted?: boolean;
        public isNew?: boolean;
        public extensionFile?: boolean;
        public attachmentId?: string;
        public commentId?: string;
    }

    export class DeletedAttachment {
        public blobPath: string;
        public fileName: string;
    }

    export class BlobImageList {
        public blob: BlobImage[];
    }

    export class BlobImage {
        public baseImage: string;
        public fileName: string;
        public fileType: string;
    }

    export class TicketTimeSpent {
        public ticketTimeId: number;
        public ticketId: string;
        public technicianId: number;
        public ticketTimeDate: string;
        public ticketTimeEndDate: string;
        public timeInMinutes: number;
        public billableStatus: number;
        public isInvoiced: boolean;
        public timeEntryComment: string;
        public billingWorkRole: number;
        public billingWorkType: number;

        public contractId: number;
        public agreementId: number;
        public clientId: number;
        public distance: number;

        //For Update
        public previousTimeSpentValue: string;
        public ticketTimeDateWithTime: string;
        public attachments: TicketModule.Attachments[] = [];

        public constructor(
            __ticketTimeId: number,
            __ticketId: string,
            __technicianId: number,
            __ticketTimeDate: string,
            __ticketTimeEndDate: string,
            __TimeInMinutes: number,
            __billableStatus: number,
            __IsInvoiced: boolean,
            __timeEntryComment: string,
            __billingWorkRole: number,
            __billingWorkType: number,
            __contractId: number,
            __agreementId: number,
            __clientId: number,
            __distance: number
        ) {
            this.ticketTimeId = __ticketTimeId;
            this.ticketId = __ticketId;
            this.technicianId = __technicianId;
            this.ticketTimeDate = __ticketTimeDate;
            this.ticketTimeEndDate = __ticketTimeEndDate;
            this.timeInMinutes = __TimeInMinutes;
            this.billableStatus = __billableStatus;
            this.isInvoiced = __IsInvoiced;
            this.timeEntryComment = __timeEntryComment;
            this.billingWorkRole = __billingWorkRole;
            this.billingWorkType = __billingWorkType;
            this.contractId = __contractId;
            this.agreementId = __agreementId;
            this.clientId = __clientId;
            this.distance = __distance;
        }
    }

    export class TicketSettings {

        public constructor(public ticketSettingsId: number, public serviceProviderId: number,
            public ticketMinimumTimeInMinutes: number, public ticketIncrementTimeInMinutes: number) { }
    }

    export class ThirdPartyConversation {

        public constructor(public thirdPartyConversationId: number, public name: string, public email: string,
            public ticketId: string, public createdById: number, public createdOn: Date) { }
    }

    export class CommentMentions {

        public constructor(public technicianId: number, public groupId: number = 0, public groupName: string = '', public isFromAllGroup: boolean = false) { }
    }

    export class MentionedTechniciansState {

        public constructor(public mentionedTechncianGroups: number[], public mentionedTechnicianIds: number[]
            , public mentionedTechnicians: TicketModule.CommentMentions[], public ticketState: string = "") { }
    }

    export class AddMentionedGroups {

        public constructor(public objSignalR: any, public objTimelineSignalR: any) { }
    }

    export class UpdateCommentForMention {

        public constructor(public comment: string, public otherTechnicianFound: boolean) { }
    }

    export class Technician {
        public technicianModel: any;
        public ticketTechnicianRole: Enums.TicketTechnicianRole;
    }

    export class CommentReactions {
        public constructor(public technicianId: number, public reactionId: number) { }
    }

    export class TicketTrackingCheckpoint {
        constructor(public createdAt: Date,
            public checkpointTime: string,
            public city: string,
            public countryISO3: string,
            public countryName: string,
            public message: string,
            public state: string,
            public tag: string,
            public zip: string,
            public slug: string,
            public location: string,
            public subtagMessage: string) {

        }
    }

    export class TicketTimeSpentDraft {

        constructor(public ticketId: string,
            public date: string,
            public startTime: any,
            public endTime: any,
            public timeInMinutes: string,
            public tempTimeInMinutes: string,
            public technician: any,
            public billingRole: any,
            public billable: any,
            public billingType: any,
            public contract: any,
            public distance: string,
            public comment: string,
            public isTimeInFraction: boolean,
            public isOffHoursTime: boolean,
            public attachments: TicketTimeSpentAttachmentDraft[]) { }
    }

    export class TicketTimeSpentAttachmentDraft {
        constructor(public name: string,
            public documentTypeId: number,
            public blobPath: string) { }
    }

}

